module.exports = __webpack_public_path__ + "img/16_127.b56af1f2.png";